import { StoreType } from '@tock/shared/utils/connect';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';

export const getSettingsSelector = (state: StoreType) => state.app.settings;

export const stripePublicKeySelector = createSelector(
  getSettingsSelector,
  (settingsState) => settingsState.STRIPE_PUBLIC_KEY
);

export const useAppSettings = () => useSelector(getSettingsSelector);
